export default __webpack_public_path__ + "images/dropdown-caret.6500e93c5265b01e1e03dd7ff328fe28.svg";